import React from "react";
import "../../styles/registration.css";
import banner from "../../assets/banner.png";
import { useNavigate } from "react-router-dom";


const Banner = () => {
    const navigate = useNavigate();
  
  return (
    <section className="banner-section p-3">
      {/* The main card container */}
      <div className="banner-card">
        {/* LEFT SIDE: Content */}
        <div className="banner-content">
          <h2 className="banner-title">
            Your Child Deserves the <br/>Best Guidance{" "}
          </h2>

          <div className="highlight-wrapper">
            <span className="highlight-text">Shaping Bright Futures.</span>
          </div>

          <button className="register-btn" onClick={() => navigate("/contact")}>Register Now</button>
        </div>

        {/* RIGHT SIDE: Image */}
        <div className="banner-image-container">

          <img
            src={banner}
            alt="Students"
            className="banner-img"
          />
        </div>
      </div>
    </section>
  );
};

export default Banner;
